import { Injectable } from '@angular/core';
import { Http } from '@angular/http';
import { Service } from '../shared/services/service';
import { Funcoes } from '../funcoes';

@Injectable()
export class UsuariosCargosNomesService extends Service {

  protected url: string = this.dominio + "/adm/usuarios-cargos-nomes/";

  constructor(protected http: Http, protected func: Funcoes) {
    super();
  }

}



// WEBPACK FOOTER //
// ./src/app/usuarios-cargos-nomes/usuarios-cargos-nomes.service.ts